// Mongolian administrative divisions used wherever the app asks "where?" — the
// post-job wizard's location step, the "Хаяг солих" editor in Миний зар, and the
// pre-screen chat.
//
// Single source of truth: these lists were previously copy-pasted into three pages,
// which is how they drift. Kept in code rather than fetched: the 9 districts and 21
// aimags are national administrative divisions that change roughly once a generation,
// so putting them behind a network call would add a failure mode to the posting flow
// without making anything more current.

/** Districts of Ulaanbaatar. */
export const DISTRICTS = [
  "Баянзүрх",
  "Баянгол",
  "Сүхбаатар",
  "Чингэлтэй",
  "Хан-Уул",
  "Сонгино хайрхан",
  "Налайх",
  "Багануур",
  "Багахангай",
];

/** Provinces outside the capital. */
export const AIMAGS = [
  "Архангай",
  "Баян-Өлгий",
  "Баянхонгор",
  "Булган",
  "Говь-Алтай",
  "Говьсүмбэр",
  "Дархан-Уул",
  "Дорноговь",
  "Дорнод",
  "Дундговь",
  "Завхан",
  "Орхон",
  "Өвөрхангай",
  "Өмнөговь",
  "Сэлэнгэ",
  "Сүхбаатар",
  "Төв",
  "Увс",
  "Ховд",
  "Хөвсгөл",
  "Хэнтий",
];

/** Whether a stored location name is a district of the capital. */
export const isUbDistrict = (name) => DISTRICTS.includes(name);
